export { default } from './chip';
export type { ChipProps } from '@mui/material/Chip';
